<script setup lang="ts">
import FloatNavigator from '@@summit/2023/components/FloatNavigator.vue';
import FloatNavigatorItem from '@@summit/2023/components/FloatNavigatorItem.vue';

import Highlights from './components/Highlights.vue';
import SummitBanner from './components/SummitBanner.vue';
import OpenSummit from './components/OpenSummit.vue';
import WaveComponent from './components/WaveComponent.vue';
import Agenda from './components/Agenda.vue';
import Journalism from './components/Journalism.vue';
import Unit from './components/Unit.vue';
import Medium from './components/Medium.vue';
// import SummitGuests from './components/SummitGuests.vue';

import { ref } from 'vue';
import { useElementVisibility } from '@vueuse/core';

const footer = ref(null);
const isVisible = useElementVisibility(footer);

defineOptions({
  name: 'PageHomeIndex',
});
</script>

<template>
  <main class="page-home-index overflow-x-hidden pb-300px">
    <SummitBanner />
    <WaveComponent />
    <FloatNavigator ref="footer">
      <FloatNavigatorItem label="开源峰会">
        <OpenSummit />
      </FloatNavigatorItem>
      <FloatNavigatorItem label="峰会亮点">
        <Highlights />
      </FloatNavigatorItem>
      <FloatNavigatorItem label="峰会议程">
        <Agenda />
      </FloatNavigatorItem>
      <FloatNavigatorItem label="最新资讯">
        <Journalism />
      </FloatNavigatorItem>
      <!-- <FloatNavigatorItem label="峰会嘉宾">
        <SummitGuests />
      </FloatNavigatorItem> -->
      <FloatNavigatorItem label="共建单位">
        <Unit />
      </FloatNavigatorItem>
      <FloatNavigatorItem label="媒体合作">
        <Medium />
      </FloatNavigatorItem>
    </FloatNavigator>
  </main>
  <div class="float-banner" :class="{ active: isVisible }">
    <a href="https://gongyi.cctv.com/special/opensource/index.shtml" class="block" target="_blank">
      <img src="https://res.oafimg.cn/-/a1f315e0c21cbbbd/live.gif" class="block h-220px">
    </a>
    <!-- <div class="qrcode">
      <img src="https://res.oafimg.cn/-/f0b41102a0b535bb/14501686023013_.pic.jpg" alt="" class="mx-auto block w-150px">
      <p>扫码立即报名峰会</p>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
.float-banner {
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 10;

  .qrcode {
    width: 162px;
    height: 0;
    margin-top: 0;
    margin-right: 0;
    margin-left: auto;
    padding: 0;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    opacity: 0;
    transition: all 0.3s;

    p {
      margin-top: 5px;
      margin-bottom: 5px;
      color: #747678;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      background: linear-gradient(93.6deg, rgb(25, 51, 143) 0%, rgb(32, 144, 204) 49%, rgb(128, 196, 141) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &.active {
    .qrcode {
      height: 196px;
      margin-top: 16px;
      padding: 6px;
      opacity: 1;
    }
  }
}
</style>
